import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';

const accessi = [
  {
    title: 'Scala esterna',
    subtitle: 'La soluzione ideale per abitazioni singole e piccoli edifici.',
    image: '/brochure/accesso-scala.jpg',
    points: ['Accesso rapido e sicuro', 'Minimo ingombro', 'Ideale per villette e case indipendenti', 'Utilizzata da personale addestrato'],
  },
  {
    title: 'Piattaforma aerea',
    subtitle: 'La soluzione più sicura per edifici alti o con accesso difficoltoso.',
    image: '/brochure/accesso-piattaforma.jpg',
    points: ['Accesso stabile e controllato', 'Raggiunge grandi altezze', 'Ideale per condomini ed edifici complessi', 'Nessun contatto diretto con la copertura'],
  },
  {
    title: "Accesso dall'interno",
    subtitle: 'Quando non è possibile utilizzare soluzioni esterne.',
    image: '/brochure/accesso-interno.jpg',
    points: ['Soluzione discreta ed efficace', 'Nessun ingombro esterno', 'Ideale per sottotetti e mansarde', 'Utilizzato con sistemi anticaduta'],
  },
];

const AccessSection = () => (
  <section id="accessi" className="py-24 md:py-32 bg-white" data-testid="access-section">
    <div className="max-w-7xl mx-auto px-6 md:px-8">
      <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="text-center mb-16">
        <span className="text-[#FF5722] text-sm font-semibold uppercase tracking-wider">Sicuri in ogni situazione</span>
        <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight text-slate-900 mt-3">Tipologie di accesso al tetto</h2>
        <p className="mt-4 text-slate-500 max-w-2xl mx-auto">Utilizziamo la soluzione più adatta in base alla tipologia dell'edificio, alle condizioni del sito e alla natura dell'intervento.</p>
      </motion.div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {accessi.map((a, i) => (
          <motion.div key={a.title} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }} className="bg-white border border-slate-200 rounded-2xl overflow-hidden hover:shadow-xl transition-all duration-300 flex flex-col">
            <div className="h-64 overflow-hidden">
              <img src={a.image} alt={a.title} loading="lazy" className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" />
            </div>
            <div className="p-6 flex-1 flex flex-col">
              <h3 className="text-lg font-bold text-slate-900 mb-1" style={{ fontFamily: 'Outfit' }}>{a.title}</h3>
              <p className="text-sm text-slate-500 mb-4">{a.subtitle}</p>
              <ul className="space-y-2 mt-auto">
                {a.points.map((p) => (
                  <li key={p} className="flex items-center gap-2 text-sm text-slate-600">
                    <CheckCircle2 className="w-4 h-4 text-emerald-500 shrink-0" />{p}
                  </li>
                ))}
              </ul>
            </div>
          </motion.div>
        ))}
      </div>
      <p className="text-center text-sm text-slate-400 mt-8">Ogni accesso viene valutato da personale qualificato con DPI specifici e nel rispetto delle normative vigenti.</p>
    </div>
  </section>
);

export default AccessSection;
